<template>
  <div class="model-second-gg-info">
    <span>创建者：{{rowData.userName}}</span>
    <span>公告范围：{{rowData | getAreaNames(nationalArea)}}</span>
    <span>创建时间：{{rowData.createTime}}</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import filters from '../filters.js'

export default {
  name: 'v-title',
  props: ['params', 'rowData'],
  filters,
  computed: {
    ...mapGetters([
      'nationalArea'
    ])
  }
}
</script>

<style lang="less">
@import "../../../styles/index.less";
</style>
